
import { CommonModule } from '@angular/common';
import { Component, Inject, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { PromptCreateService } from '../services/prompt-create.service';
import { DashboardService } from '../services/shared/dashboard.service';
// import { SaveSuccessComponent } from '../save-success/save-success.component';
import { SubmitSuccessComponent } from '../components/common/submit-success/submit-success.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UpdateSuccessComponent } from '../update-success/update-success.component';
import { MatDividerModule } from '@angular/material/divider';
import { ButtonComponent } from '../components/common/components/button/button.component';


@Component({
  selector: 'app-on-update',
  standalone: true,
  imports: [MatDialogModule, CommonModule, FormsModule, MatIconModule, MatSelectModule, ReactiveFormsModule,MatDividerModule,ButtonComponent],
  templateUrl: './on-update.component.html',
  styleUrl: './on-update.component.scss'
})
export class OnUpdateComponent {
  title = new FormControl();
  description = new FormControl();
  notes = new FormControl();
  actionType: string = "add"
  cancelButtonText = "Cancel"
  selectedrating: number = -1;
  isSubmitDisabled: boolean = false;
  isCommentRequired: boolean = false;
  comments: string = '';
  selectedValue: number = 0;
  allcategory: any;
  promptUserService: any;
  promptUserDetails: any;
  fileNames: any[] = [];
  promptCreatedBy: unknown;
  promptCategory: unknown;
  categories: any = [];
  subcategories: any = [];
  promptDetails: any;
  userid: any;
  modal: any;
  createdbyarray: any;
  category_id: any = [];
  sub_category_id: any = null;
  onMyFavouriteClick: boolean = false;
  onMyPromptsClick: boolean = false;
  user_role: any;
  status: any = [];
  prompt_id: any;
  selectedCategory: any
  promptDetailsObj: any = [];
  successfullySavedData: any;
  fromGroup: boolean = false;
  promptFromCreateForm: string = ''; 
  titleRequired: boolean = false;
  categoryRequired: boolean = false;
  SubcategoryRequired: boolean = false;
  category: any;
  attch: any;
  permentattch: any;
  newAttachments: string[] = [];
  attachmentData: any;
  permentattchData: any;
  variable:any;
  attchemnts:any=[];
  permaAttah:any=[];
  attachment:any=[];
  version:number=0;
  variant:number=0;
  time: string = "00.00"
  time_val = signal<boolean>(false);
  isSaveClicked: boolean = false;
  timeFloat: number = 0.0

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<OnUpdateComponent>, private promptCreateService: PromptCreateService, private fb:FormBuilder, private dialog: MatDialog, private dashboardService: DashboardService, private router : Router) {

      this.promptCreateService.promptSaveResp$.subscribe( resp =>{
        if(resp){
      
          this.successfullySavedData = resp
        }
      });


    // this.dashboardService.currentData.subscribe((data: any) => {
    //   // this.userid = data
    //   // if (this.userid == 1) {
    //   //   this.user_role = "admin"
    //   // }
    //   // else if (this.userid == 2) {
    //   //   this.user_role = "curator"
    //   // }
    //   // else if (this.userid == 3) {
    //   //   this.user_role = "creator"
    //   // }
    //   // else if (this.userid == 4) {
    //   //   this.user_role = "user"
    //   // }
    // });

    if (data) {
  
      this.title.setValue(data?.title);
      this.promptDetails = this.successfullySavedData?.prompt_details[0];
      this.description.setValue(data?.promptData?.description)
      this.notes.setValue(data.promptData?.notes || this.successfullySavedData?.prompt?.notes)
      this.category_id = data?.category?.category_id;
      this.categories = data?.promptData?.categories;
      // this.subcategories = data.subcategories
      this.selectedCategory = this.categories.find((c: any) => c.id == Number(this.category_id))
      this.subcategories = this.selectedCategory?.value?.subcategories ? this.selectedCategory.value.subcategories : [];
      // this.category.setValue(data?.promptData?.categories?.name);
      this.variable=data?.promptData?.prompt_variable;
      this.attchemnts=data?.promptData?.attachments;
      this.permaAttah=data?.promptData?.perminentAttachments;
      this.attachment=data?.attachmentTab;
      this.version=data?.promptUserDetails?.version;
      this.variant=data?.promptUserDetails?.variant;
   
      // this.promptFromCreateForm = data.promptData.promptDetails;
      if(data?.estimated_time) {
        let float_time = parseFloat(data?.estimated_time).toFixed(2);
        this.time = float_time;

        let isValidTime = Number(this.time);
        this.time_val.set(isValidTime > 0 ? true : false);
        this.timeFloat = parseFloat(this.time)
      }
    }
    this.dialogRef.updateSize('300vw', '300vw')
  }

  ngOnInit() {
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onClose() {
    this.dialogRef.close(true);
  }

  selectCategory(event: any) {
    this.categoryRequired = false;
    this.category_id = +(event.target as HTMLSelectElement).value
    const selectedcat = this.category_id;
    let a = this.categories.filter((cat: any) => {
      if (cat.id == this.category_id) {
        return cat
      }
    });
    this.subcategories = a && a.length > 0 ? a[0].value.subcategories : [];
    this.sub_category_id = this.subcategories[0]?.id;
  }


  selectSubCategory(event:any){
    this.sub_category_id = +(event.target as HTMLSelectElement).value
  }


  onChange(event: any) {
    if (event !== null || event !== undefined || event !== '' ) {
      this.fromGroup = false;
    }
  }

  onTitleChange(event: any){
    if (event !== null || event !== undefined || event !== '' ) {
      this.titleRequired = false;
    }
  }
  // onCategoryChange(event: any){
  //   if (event !== null || event !== undefined || event !== '' ) {
  //     this.categoryRequired = false;
  //   }
  // }

  private parseTime(): { hours: number, minutes: number } {
    const [h, m] = this.time.split(".").map(Number);
    return {
      hours: isNaN(h) ? 0 : Math.min(Math.max(h, 0), 99), 
      minutes: isNaN(m) ? 0 : Math.min(Math.max(m, 0), 59)
    }
  }

  private formatTime(h: number, m: number): string {
    const hh = String(h).padStart(2, '0');
    const mm = String(m).padStart(2, '0');
    return `${hh}.${mm}`
  }

  increaseHour() {
    const {hours,  minutes} = this.parseTime();
    const newHours = Math.min(hours + 1, 99);
    this.time = this.formatTime(newHours, minutes)

    let isValidTime = Number(this.time);
    this.time_val.set(isValidTime > 0 ? true : false);
    this.timeFloat = parseFloat(this.time)
  }

  decreaseHour() {
    const {hours, minutes} = this.parseTime();
    const newHours = Math.max(hours - 1, 0);
    this.time = this.formatTime(newHours, minutes);
    
    let isValidTime = Number(this.time);
    this.time_val.set(isValidTime > 0 ? true : false);
    this.timeFloat = parseFloat(this.time)
  }

  validateAndFormatTime() {
    const timePattren = /^(\d{1,2}).([0-5]\d)$/;
    let validTime = parseFloat(this.time).toFixed(2);
    const match = validTime.match(timePattren);

    if(match) {
      let hours = parseInt(match[1], 10);
      let minutes = parseInt(match[2], 10);

      if (hours > 99) hours = 99;
      if (minutes > 59) minutes = 59;

      this.time = this.formatTime(hours, minutes);
      this.timeFloat = parseFloat(this.time);

      let isValidTime = Number(this.time);
      this.time_val.set(isValidTime > 0 ? true : false);
    } else {
      this.time = '00.00'; // fallback if invalid
      let isValidTime = Number(this.time);
      this.time_val.set(isValidTime > 0 ? true : false);
    }
  }

  onSubmit() {
    this.isSaveClicked = false
    this.promptDetailsObj = [];
    this.data.promptUserDetails.prompt_details.forEach((element: any,index:number) => {
      this.promptDetailsObj.push({
        "prompt_name": element.prompt_name,
      "prompt": element.prompt || "",
      "prompt_detail_id": element.prompt_detail_id ?? null,
      "order_number": element.order_number,
      "model_id": element.llm.model_id,
      "permanent_attachments": this.attachment[index]?.permanentAttachments,
      //this.permaAttah, //element?.permanent_attachments?.map((attachment: any) => attachment) ?? [],
      "attachments":this.attachment[index]?.otherAttachment,//this.attchemnts,//element?.attachments?.map((attachment: any) => attachment) ?? [], //,//
      "variables": this.variable[index],
      "notes":element?.notes,
      // [
      //   "c7",
      //   ["c7_1", "c7_2"]
      // ]
      })
    });
    // let obj = {
    //   "prompt_name": this.title.value,

    //   "prompt": this.promptDetails?.prompt || this.promptFromCreateForm || "",
    //   "prompt_detail_id": this.promptDetails?.id ?? null,
    //   "order_number": 1,
    //   "model_id": 2,
    //   "permanent_attachments": this.promptDetails?.permanent_attachments.map((attachment: any) => attachment) ?? [],
    //   "attachments": this.promptDetails?.attachments?.map((attachment: any) => attachment) ?? [],
    //   "variables": [
    //     "c7",
    //     ["c7_1", "c7_2"]
    //   ]
    // }

 
    //return;
    // this.promptDetailsObj.push(obj)
    let request = {
      "title": this.title.value,
      "description": this.description.value,
      "notes": this.notes.value ?? '',
      "category_id": parseInt(this.category_id),
      "sub_category_id": this.sub_category_id ?  this.sub_category_id : this.data.promptUserDetails?.sub_category?.sub_category_id,
      "prompt_id": this.data?.promptData?.prompt_id ? (this.data?.promptData?.prompt_id || this.successfullySavedData?.prompt?.id) : null,
       "user_id": +this.userid,
      "action_type": 'submit',
      "prompt_type":  this.data.promptUserDetails.prompt_type,
      "prompt_details": this.promptDetailsObj,
      "estimated_time": this.timeFloat
    }

    if (this.title.value === undefined || this.title.value === '') {
      this.titleRequired = true;
    }
    if (this.description.value === undefined) {
      this.fromGroup = true;
    }
    if (this.category_id === undefined) {
      this.categoryRequired = true;
    }
    if(this.subcategories.length > 0 &&  this.sub_category_id === undefined){
      this.SubcategoryRequired = true;
    }
    if (this.titleRequired || this.fromGroup || this.categoryRequired || this.SubcategoryRequired || !this.time_val()){
      this.isSaveClicked = true
      return;
    }

   
    // return;
    this.title.value ? (
      this.promptCreateService?.OnSubmit(request)?.subscribe(res => {
        if (res.status_code === 200) {
          this.promptCreateService.promptSaveResp$.next(null);
          const preSignedUrlRequest = {
            prompt_id: res?.data?.prompt?.id,
            title: res?.data?.prompt?.title,
            url_type: 'put_object',
            prompt_details: res?.data?.prompt_details?.map((detail: any) =>
              ({
                prompt_detail_id: detail?.id,
                permanent_attachments: detail?.permanent_attachments,
                attachments: detail?.attachments,
              }))
          };
          // this.promptCreateService.getPreSignedUrl(preSignedUrlRequest).subscribe(res => {
          //   if(res.status_code === 200) {
          //     const { prompt_details } = res?.data;
          //     prompt_details?.forEach((detail: any) => {
          //       detail?.permanent_attachments?.forEach((attachment: any) => {
          //         const file = this.promptDetails.perminentAttachments?.find((file: any) => file?.name === attachment?.file_name)
          //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
          //           
          //         })
          //       })
          //       detail?.attachments?.forEach((attachment: any) => {
          //         const file = this.promptDetails.attachments?.find((file: any) => file?.name === attachment?.file_name)
          //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
          //           
          //         })
          //       })
          //     })
          //   }
          // })
  
          // -------------------- code for upload to s3 using presigned url -----
          if (res?.data?.prompt_details) {
            res?.data?.prompt_details?.forEach((each_prompt_detail: { permanent_attachments: any[]; id: any; attachments: any[]; }) => {
              let newTempPerAttach: any = [];
                this.permentattchData?.forEach((item: any) => {
                  if (item.file_type) {
                    newTempPerAttach.push(item.selected.name);
                  }
                });
                if(newTempPerAttach.length > 0) {
                  each_prompt_detail?.permanent_attachments.forEach(each_permanent_attachments => {
                    if (newTempPerAttach.includes(each_permanent_attachments)) {
                      const presSignedUrlRequest = {
                        prompt_id: res?.data?.prompt?.id,
                        title: res?.data?.prompt?.title,
                        url_type: 'put_object',
                        prompt_detail_id: each_prompt_detail?.id,
                        attachment_type: "permanent_attachments",
                        file_name: each_permanent_attachments,
                        user_id:this.userid
                      }
                      this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
                          if (response?.data) {
                            const presignedUrl = response?.data?.url;
                            const file = this.permentattch?.find((file: any) => file.selected.name === each_permanent_attachments)
                             
                            this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
                                  next: (res) => {
                                    
                                    // alert("File uploaded successfully");
                                  },
                                  error: (error) => {
                                    console.error("Error uploading file:", error);
                                    // alert("File upload failed");
                                  }
                                });
            
                          } else {
                            
                          }
                      })
                    }
                  })
                }

                let newTempAttach: any = [];
                this.attachmentData?.forEach((item: any) => {
                  if (item.type) {
                    newTempAttach.push(item.name); 
                  }
                });
                if(newTempAttach.length > 0) {
                  each_prompt_detail?.attachments.forEach(each_attachments => {
                    if (newTempAttach.includes(each_attachments)) {
                      const presSignedUrlRequest = {
                        prompt_id: res?.data?.prompt?.id,
                        title: res?.data?.prompt?.title,
                        url_type: 'put_object',
                        prompt_detail_id: each_prompt_detail?.id,
                        attachment_type: "attachments",
                        file_name: each_attachments,
                        user_id:this.userid
                      }
                      this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
                        if (response?.data) {
                          const presignedUrl = response?.data?.url;
                          const file = this.attch?.find((file: any) => file.selected.name === each_attachments)
                          
         
                          this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
                            next: (res) => {
                              
                              newTempAttach = []; 
                            },
                            error: (error) => {
                              console.error("Error uploading file:", error);
                              // alert("File upload failed");
                            }
                          });
                        } else {
                          
                        }
                      })
                    }
                  })
                }
            })
          }
  
          let messageData;
          const variant = res?.data?.prompt?.variant;
          const version = res?.data?.prompt?.version;
          const promptTitle = res?.data?.prompt?.title;
          
          if (res?.data?.prompt_details && res?.data?.prompt_details.length > 1) {
            messageData = 'The prompt chain ';
            if ((variant >= 1) && (version >= 1)) {
              messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
            } else if ((variant >= 1) && (version < 1)) {
              messageData += `'${promptTitle} - Variant ${variant}'`;
            } else if ((version >= 1 && (variant < 1))) {
              messageData += `'${promptTitle} - Version ${version}'`;
            } else {
              messageData += `'${promptTitle}'`;
            }
            messageData += ' has been updated successfully';
          } else if(res?.data?.prompt_details && res?.data?.prompt_details.length == 1) {
            messageData = 'The prompt ';
            if ((variant >= 1) && (version >= 1)) {
              messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
            } else if ((variant >= 1) && (version < 1)) {
              messageData += `'${promptTitle} - Variant ${variant}'`;
            } else if ((version >= 1 && (variant < 1))) {
              messageData += `'${promptTitle} - Version ${version}'`;
            } else {
              messageData += `'${promptTitle}'`;
            }
            messageData += ' has been updated successfully';
          }
  
          const dialogRef = this.dialog.open(UpdateSuccessComponent, {
            
            data: {
              message: messageData,
              title: "Updated successfully",
              action_type: 'submit'
            }
          });
          this.dialogRef.close(res?.data);
        } else {
          this.promptDetailsObj = []
          this.promptCreateService.promptSaveResp$.next(null);
        }
      } , (error : HttpErrorResponse) => {
        // const dialogRef = this.dialog.open(SubmitSuccessComponent, {
        //   data: {
        //     message: '',
        //     title: "Error",
        //   }
        // });
        
      })
    ) : {};


  }


}

